import Vue from 'vue';
import getNewsQuery from '../data/news-query';

Vue.component('load-more-news-component', {
    props: {
        siteHandle: {
            type: String,
            default: 'default',
            required: true
        },

        itemsPerLoad: {
            type: Number,
            default: 10
        },

        excludeId: {
            type: Number,
            default: null,
        }
    },

    data() {
        return {
            newsItems: [],
            currentIndex: 0,
            offset: 0,
            newsItemsTotal: 0,
            isLoading: false
        };
    },

    computed: {
        sortedNewsItems() {
            const rows = [];
            let row = [];

            for (let i = 0; i < this.newsItems.length; i++) {
                row.push(this.newsItems[i]);

                if (i % 5 === 4 || (i + 1) === this.newsItemsTotal) {
                    rows.push(row);
                    row = [];
                }
            }

            this.isLoading = false;

            return rows;
        }
    },

    mounted() {
        this.isLoading = true;
        this.fetchNextPage();
    },

    methods: {
        /**
         * Instance of a fetch function
         * 
         * @param {String} query 
         * @param {Object} variables 
         * @returns {Array}
         */
        async fetchGQL(query, { variables } = {}) {
            const headers = { 'Content-Type': 'application/json' };

            const res = await fetch(`${window.location.origin}/api`, {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    query,
                    variables
                })
            });

            const json = await res.json();

            if (json.errors) {
                const message = json.errors[0] ? json.errors[0].message : json.errors;
                throw new Error(message);
            }

            return json.data;
        },

        /**
         * Get next news items
         * 
         * @returns {Void}
         */
        getNextItems() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            this.currentIndex++;
            this.fetchNextPage();
        },

        /**
         * Function that will fetch the next news items
         * Sets the results to the newsItems array
         * 
         * @returns {Void}
         */
        async fetchNextPage() {
            try {
                const response = await this.fetchGQL(getNewsQuery, {
                    variables: {
                        site: this.siteHandle,
                        section: 'news',
                        limit: this.itemsPerLoad,
                        offset: this.currentIndex * this.itemsPerLoad,
                        id: `not ${this.excludeId}`
                    }
                });

                this.newsItemsTotal = response.total - 1; // -1 because of the single highlighted header news item
                this.newsItems = [...this.newsItems, ...response.data];
            } catch (error) {
                console.error(`[Error fetching getNewsItems]: ${error}`);
            }
        }
    },

    beforeDestroy() { },
});
